/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboPouchManagementBadRequestResponse,
  BboPouchManagementFailureResponseResponse,
  BboPouchManagementForbiddenResponse,
  GetPouchAcceptanceListResponseResponse,
  UnauthorizedResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * This api to get the list of expected pouches in the branch.
 * @summary Get expected list of pouches in the branch
 */
export const getAcceptanceList = (signal?: AbortSignal) => {
  return customInstance<GetPouchAcceptanceListResponseResponse>({
    url: `/bm-pouch-management/v1/acceptance/list`,
    method: 'get',
    signal,
  });
};

export const getGetAcceptanceListQueryKey = () => {
  return [`/bm-pouch-management/v1/acceptance/list`] as const;
};

export const getGetAcceptanceListQueryOptions = <
  TData = Awaited<ReturnType<typeof getAcceptanceList>>,
  TError = ErrorType<
    | BboPouchManagementBadRequestResponse
    | UnauthorizedResponse
    | BboPouchManagementForbiddenResponse
    | BboPouchManagementFailureResponseResponse
  >,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAcceptanceList>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAcceptanceListQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAcceptanceList>>> = ({ signal }) =>
    getAcceptanceList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAcceptanceList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAcceptanceListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAcceptanceList>>
>;
export type GetAcceptanceListQueryError = ErrorType<
  | BboPouchManagementBadRequestResponse
  | UnauthorizedResponse
  | BboPouchManagementForbiddenResponse
  | BboPouchManagementFailureResponseResponse
>;

/**
 * @summary Get expected list of pouches in the branch
 */
export const useGetAcceptanceList = <
  TData = Awaited<ReturnType<typeof getAcceptanceList>>,
  TError = ErrorType<
    | BboPouchManagementBadRequestResponse
    | UnauthorizedResponse
    | BboPouchManagementForbiddenResponse
    | BboPouchManagementFailureResponseResponse
  >,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAcceptanceList>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetAcceptanceListQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
